export {
  ZOOM_INITIAL,
  ZOOM_MAX,
  ZOOM_MIN,
  ZOOM_STEP,
} from '@blocksuite/std/gfx';
export const GRID_SIZE = 3000;
export const GRID_GAP_MIN = 5;
export const GRID_GAP_MAX = 80;
export const DEFAULT_NOTE_OFFSET_X = 30;
export const DEFAULT_NOTE_OFFSET_Y = 40;

// ---- Canvas backgrounds ----

/** Base world-space gap between the graph explorer's grid dots (px) */
export const GRID_WORLD_GAP = 20;

/** Minimum screen-space gap before LOD doubles the world gap */
export const GRID_MIN_SCREEN_GAP = 10;

/** A flat light from above on dark canvas backgrounds. */
export const DARK_CANVAS_SPOTLIGHT_GRADIENT =
  'radial-gradient(ellipse 140% 80% at 50% 0%, rgba(255,255,255,0.025) 0%, transparent 70%)';

/** Default for renderers whose surfaces are always dark. */
export const CANVAS_SPOTLIGHT_GRADIENT = DARK_CANVAS_SPOTLIGHT_GRADIENT;

/** A flat, neutral light from above on light canvas backgrounds. */
export const LIGHT_CANVAS_SPOTLIGHT_GRADIENT =
  'radial-gradient(ellipse 140% 80% at 50% 0%, rgba(255,255,255,0.03) 0%, transparent 70%)';

export type EdgelessGridStyle = 'dots' | 'crosses' | 'lines';

export const DEFAULT_EDGELESS_GRID_STYLE: EdgelessGridStyle = 'dots';
export const EDGELESS_GRID_STYLE_ATTRIBUTE = 'data-streamlain-grid-style';
export const EDGELESS_GRID_STYLE_CHANGED_EVENT =
  'streamlain:edgeless-grid-style-changed';

export function normalizeEdgelessGridStyle(value: unknown): EdgelessGridStyle {
  return value === 'dots' || value === 'crosses' || value === 'lines'
    ? value
    : DEFAULT_EDGELESS_GRID_STYLE;
}

/**
 * Calculate screen-space grid gap with LOD.
 * Linear scaling with min-only clamp (prevents dot flicker on zoom-out).
 */
export function calculateGridScreenGap(zoom: number): number {
  let worldGap = GRID_WORLD_GAP;
  while (worldGap * zoom < GRID_MIN_SCREEN_GAP) worldGap *= 2;
  return worldGap * zoom;
}

// TODO: need to check the default central area ratio
export const DEFAULT_CENTRAL_AREA_RATIO = 0.3;

export interface IModelCoord {
  x: number;
  y: number;
}

// TODO(@L-Sun): we should remove this list when refactor the pointerOut event to pointerLeave,
// since the previous will be triggered when the pointer move to the area of the its children elements
// see: https://developer.mozilla.org/en-US/docs/Web/API/Element/pointerout_event
export const EXCLUDING_MOUSE_OUT_CLASS_LIST = [
  'affine-note-mask',
  'edgeless-block-portal-note',
  'affine-block-children-container',
  'edgeless-container',
];
